import { openPremiumPageUpgradeModal } from '@gik/checkout/utils/openPremiumPageUpgradeModal';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { checkReminder } from '@gik/create/components/Reminder/openReminder';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { UI } from '@gik/ui/UIManager';
import type moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import UpgradePageReminder from './UpgradePageReminder.svg';

function UpgradePageReminderContent() {
  const bem = useBemCN('upgrade-page-reminder');
  const { t } = useTranslation();
  return (
    <div {...bem()}>
      <div {...bem('image-container')}>
        <UpgradePageReminder />
      </div>
      <div {...bem('content')}>
        <h1>{t(translationKeys.UpgradePageReminderTitle)}</h1>
        <p>{t(translationKeys.UpgradePageReminderDescription)}</p>
      </div>
    </div>
  );
}

export function checkUpgradePageReminder(pageCreatedDate: moment.Moment, updateUserSeenPageReminders: () => void) {
  checkReminder(
    () => {
      updateUserSeenPageReminders();
      UI.notify(<UpgradePageReminderContent />, {
        autoClose: false,
        clickThrough: true,
        onClickThrough: () =>
          openPremiumPageUpgradeModal({
            initiatedOn: 'inkindPage',
            variant: 'generic',
          }),
      });
    },
    'upgrade-page-reminder',
    pageCreatedDate,
    null,
    null,
    24,
    [],
    false
  );
}
